import http from './index'

const queryTransaction = async (id) => {
    return await http.get('/get/transaction/' + id)
}

export { queryTransaction }
